<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <base-input v-model="supplier.name" label="Name" v-uppercase></base-input>
        <base-input v-model="supplier.address" label="Address" v-uppercase></base-input>
      </div>
      <div class="col-md-6">
        <base-input v-model="supplier.phone" label="Phone"></base-input>
        <base-input v-model="supplier.gstNumber" label="GST No."></base-input>
      </div>
    </div>
    <base-button md type="primary" @click="onSubmit()">Save</base-button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
export default {
     directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },
  data: () => {
    return {
     
    };
  },
  
  computed :{
    ...mapState("supplier",["supplier"]),
   // ...mapGetters({supplier:'supplier/getSupplier'})
  },
  
  methods:{
    ...mapActions({saveSupplier:'supplier/saveSupplier',updateSupplier:'supplier/updateSupplier',getSupplierList:'supplier/getSupplierList'}),
    onSubmit(){
        if (this.supplier.supplierId) {
        this.updateSupplier().then(res => {
          this.$notify({
            message: "Supplier Updated Succesfully!",
            type: "success",
            title:"Succes"
          });
          this.getSupplierList();
          this.$emit("close");
        });
      } else {
           this.saveSupplier().then(res => {
          this.$notify({
            message: "Supplier Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getSupplierList();
          this.$emit("close");
        });
      }
    }
  },
   
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  }
};

</script>

